package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.style.TextOverflow
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.GemArt
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.gemArtImage
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Fact
import diana.soleil.design.iraniancanadienbazzar.core.model.Joke
import diana.soleil.design.iraniancanadienbazzar.core.model.Poem
import diana.soleil.design.iraniancanadienbazzar.core.model.Recipe
import diana.soleil.design.iraniancanadienbazzar.core.model.Story
import diana.soleil.design.iraniancanadienbazzar.core.model.Tale
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_coming_soon_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_coming_soon_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_error
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_item_count
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_poet_count
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_fal_count
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_fal
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_fal_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_story_count
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_poetry
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_poetry_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_stories
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_stories_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_retry
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_saved_action_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_saved_empty
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_saved_rail
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_saved_sheet_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_jokes
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_jokes_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_danestaniha
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_danestaniha_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_shahnameh
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_shahnameh_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_recipes
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_section_recipes_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_unavailable_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_unavailable_title
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/**
 * Stateful entry for the Hidden Gems hub (`/gems`). Checks the `feature_hiddengems_enabled` kill
 * switch itself so a stale shortcut/deep link renders a friendly not-available state instead of
 * the feature (the Home entry rail is hidden separately).
 */
@Composable
fun GemsHubRoute(
    onBack: () -> Unit,
    onOpenJokes: () -> Unit,
    onOpenRecipes: () -> Unit,
    onOpenDanestaniha: () -> Unit,
    onOpenShahnameh: () -> Unit,
    onOpenPoetry: () -> Unit = {},
    onOpenStories: () -> Unit = {},
    onOpenFal: () -> Unit = {},
    onOpenRecipe: (recipeId: String) -> Unit,
    onOpenTale: (taleId: String) -> Unit = {},
    onOpenPoem: (poemId: String) -> Unit = {},
    onOpenStory: (storyId: String) -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: GemsHubViewModel = koinViewModel(),
) {
    val features by koinInject<FeatureFlags>().available.collectAsState()
    if (!features.hiddenGems) {
        Column(modifier = modifier.fillMaxSize().background(AppTheme.colors.background).statusBarsPadding().navigationBarsPadding()) {
            GemsTopBar(onBack = onBack)
            EmptyState(
                title = stringResource(Res.string.gems_unavailable_title),
                description = stringResource(Res.string.gems_unavailable_desc),
            )
        }
        return
    }
    val state by viewModel.state.collectAsStateWithLifecycle()
    GemsHubScreen(
        state = state,
        danestanihaEnabled = features.danestaniha,
        shahnamehEnabled = features.shahnameh,
        poetryEnabled = features.poetry,
        storiesEnabled = features.stories,
        falEnabled = features.fal,
        onBack = onBack,
        onOpenJokes = onOpenJokes,
        onOpenRecipes = onOpenRecipes,
        onOpenDanestaniha = onOpenDanestaniha,
        onOpenShahnameh = onOpenShahnameh,
        onOpenPoetry = onOpenPoetry,
        onOpenStories = onOpenStories,
        onOpenFal = onOpenFal,
        onOpenRecipe = onOpenRecipe,
        onOpenTale = onOpenTale,
        onOpenPoem = onOpenPoem,
        onOpenStory = onOpenStory,
        modifier = modifier,
    )
}

/**
 * Hidden Gems hub — the "treasure box" landing (Stitch ID pending, generation timed out
 * 2026-07-19; built from `docs/HIDDEN_GEMS_PLAN.md` §6): section cards grid, a dashed
 * "coming soon" teaser, and a saved-gems rail when non-empty. Tokens + string resources only.
 */
@Composable
fun GemsHubScreen(
    state: GemsHubUiState,
    danestanihaEnabled: Boolean,
    shahnamehEnabled: Boolean,
    poetryEnabled: Boolean = true,
    storiesEnabled: Boolean = true,
    falEnabled: Boolean = true,
    onBack: () -> Unit,
    onOpenJokes: () -> Unit,
    onOpenRecipes: () -> Unit,
    onOpenDanestaniha: () -> Unit,
    onOpenShahnameh: () -> Unit,
    onOpenPoetry: () -> Unit = {},
    onOpenStories: () -> Unit = {},
    onOpenFal: () -> Unit = {},
    onOpenRecipe: (recipeId: String) -> Unit,
    onOpenTale: (taleId: String) -> Unit = {},
    onOpenPoem: (poemId: String) -> Unit = {},
    onOpenStory: (storyId: String) -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val lang = AppTheme.language
    var showSavedSheet by remember { mutableStateOf(false) }
    val anySaved = state.savedJokes.isNotEmpty() || state.savedRecipes.isNotEmpty() ||
        state.savedFacts.isNotEmpty() || state.savedTales.isNotEmpty() ||
        state.savedPoems.isNotEmpty() || state.savedStories.isNotEmpty()
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(AppTheme.colors.background)
            .statusBarsPadding().navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        GemsTopBar(onBack = onBack, onOpenSaved = { showSavedSheet = true })
        when {
            state.loading -> LoadingState()
            // Live snapshot streams reconnect on their own — no manual retry affordance needed.
            state.error -> EmptyState(title = stringResource(Res.string.gems_error))
            else -> Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(rememberScrollState()),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Column(
                    modifier = Modifier
                        .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                        .fillMaxWidth()
                        .padding(horizontal = AppTheme.spacing.lg)
                        .padding(bottom = AppTheme.spacing.xl),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                ) {
                    Text(
                        text = stringResource(Res.string.gems_subtitle),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                    // Two-up section cards: the launch gems (plan §2). IntrinsicSize.Min + fillMaxHeight
                    // makes both cards match the taller one, so a title that wraps to two lines
                    // ("Recipes & Sweets") doesn't leave the grid lopsided.
                    Row(
                        modifier = Modifier.height(IntrinsicSize.Min),
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    ) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_jokes),
                            description = stringResource(Res.string.gems_section_jokes_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_item_count,
                                state.jokeCount,
                                lang.formatCount(state.jokeCount),
                            ),
                            art = GemArt.Jokes,
                            onClick = onOpenJokes,
                            modifier = Modifier.weight(1f).fillMaxHeight(),
                        )
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_recipes),
                            description = stringResource(Res.string.gems_section_recipes_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_item_count,
                                state.recipeCount,
                                lang.formatCount(state.recipeCount),
                            ),
                            art = GemArt.Recipes,
                            onClick = onOpenRecipes,
                            modifier = Modifier.weight(1f).fillMaxHeight(),
                        )
                    }
                    // Danestaniha ("did you know?" facts) — full-width feature card below the
                    // 2-up launch gems, gated by its own `feature_danestaniha_enabled` flag.
                    if (danestanihaEnabled) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_danestaniha),
                            description = stringResource(Res.string.gems_section_danestaniha_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_item_count,
                                state.factCount,
                                lang.formatCount(state.factCount),
                            ),
                            art = GemArt.Danestaniha,
                            onClick = onOpenDanestaniha,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    // Shahnameh — prose retellings of Ferdowsi's tales; own kill switch.
                    if (shahnamehEnabled) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_shahnameh),
                            description = stringResource(Res.string.gems_section_shahnameh_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_item_count,
                                state.taleCount,
                                lang.formatCount(state.taleCount),
                            ),
                            art = GemArt.Shahnameh,
                            onClick = onOpenShahnameh,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    // Persian poetry — public-domain classical verse with our own translations.
                    if (poetryEnabled) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_poetry),
                            description = stringResource(Res.string.gems_section_poetry_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_poet_count,
                                state.poetCount,
                                lang.formatCount(state.poetCount),
                            ),
                            art = GemArt.Poetry,
                            onClick = onOpenPoetry,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    // Fal-e Hafez — one tap opens the Divan; draws only Hafez poems that carry a reading.
                    if (falEnabled) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_fal),
                            description = stringResource(Res.string.gems_section_fal_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_fal_count,
                                state.falCount,
                                lang.formatCount(state.falCount),
                            ),
                            art = GemArt.Hub,
                            onClick = onOpenFal,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    // Regional short stories — our retellings of traditional folk material.
                    if (storiesEnabled) {
                        GemSectionCard(
                            title = stringResource(Res.string.gems_section_stories),
                            description = stringResource(Res.string.gems_section_stories_desc),
                            countLabel = pluralStringResource(
                                Res.plurals.gems_story_count,
                                state.storyCount,
                                lang.formatCount(state.storyCount),
                            ),
                            art = GemArt.Stories,
                            onClick = onOpenStories,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                    ComingSoonCard()
                    if (anySaved) {
                        SectionHeader(title = stringResource(Res.string.gems_saved_rail))
                        SavedGemsRail(
                            savedJokes = state.savedJokes,
                            savedRecipes = state.savedRecipes,
                            savedFacts = state.savedFacts,
                            savedTales = state.savedTales,
                            savedPoems = state.savedPoems,
                            savedStories = state.savedStories,
                            onOpenJokes = onOpenJokes,
                            onOpenDanestaniha = onOpenDanestaniha,
                            onOpenShahnameh = onOpenShahnameh,
                            onOpenRecipe = onOpenRecipe,
                            onOpenTale = onOpenTale,
                            onOpenPoem = onOpenPoem,
                            onOpenStory = onOpenStory,
                        )
                    }
                }
            }
        }
    }
    if (showSavedSheet) {
        AppBottomSheet(
            onDismissRequest = { showSavedSheet = false },
            title = stringResource(Res.string.gems_saved_sheet_title),
        ) {
            if (!anySaved) {
                Text(
                    text = stringResource(Res.string.gems_saved_empty),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                    modifier = Modifier.padding(AppTheme.spacing.lg),
                )
            } else {
                Column(modifier = Modifier.padding(bottom = AppTheme.spacing.lg)) {
                    state.savedPoems.forEach { poem ->
                        SavedSheetRow(
                            iconName = "history_edu",
                            label = poem.title.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                onOpenPoem(poem.id)
                            },
                        )
                    }
                    state.savedStories.forEach { story ->
                        SavedSheetRow(
                            iconName = "auto_stories",
                            label = story.title.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                onOpenStory(story.id)
                            },
                        )
                    }
                    state.savedRecipes.forEach { recipe ->
                        SavedSheetRow(
                            iconName = "skillet",
                            label = recipe.title.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                onOpenRecipe(recipe.id)
                            },
                        )
                    }
                    state.savedTales.forEach { tale ->
                        SavedSheetRow(
                            iconName = "menu_book",
                            label = tale.title.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                // Open the specific tale (was dropping the user on the Shahnameh list).
                                onOpenTale(tale.id)
                            },
                        )
                    }
                    state.savedFacts.forEach { fact ->
                        SavedSheetRow(
                            iconName = "lightbulb",
                            label = fact.text.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                onOpenDanestaniha()
                            },
                        )
                    }
                    state.savedJokes.forEach { joke ->
                        SavedSheetRow(
                            iconName = "sentiment_very_satisfied",
                            label = joke.text.resolve(lang),
                            onClick = {
                                showSavedSheet = false
                                onOpenJokes()
                            },
                        )
                    }
                }
            }
        }
    }
}

/** Shared hub top bar: back, localized title, optional saved-gems action (Stitch-pending spec). */
@Composable
private fun GemsTopBar(onBack: () -> Unit, onOpenSaved: (() -> Unit)? = null) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppIconButton(
            iconName = "arrow_back",
            contentDescription = stringResource(Res.string.gems_back_a11y),
            onClick = onBack,
            tint = AppTheme.colors.onSurface,
        )
        Text(
            text = stringResource(Res.string.gems_title),
            style = AppTheme.typography.headlineLg,
            color = AppTheme.colors.onSurface,
            modifier = Modifier.weight(1f),
        )
        if (onOpenSaved != null) {
            AppIconButton(
                iconName = "bookmarks",
                contentDescription = stringResource(Res.string.gems_saved_action_a11y),
                onClick = onOpenSaved,
                tint = AppTheme.colors.onSurface,
            )
        }
    }
}

/**
 * One hub section card: a Fluent-Emoji-3D cover (same art system as the business category tiles,
 * see [gemArtImage]) over a soft neutral panel, then title, one-liner, item-count pill.
 */
@Composable
private fun GemSectionCard(
    title: String,
    description: String,
    countLabel: String,
    art: GemArt,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    AppCard(modifier = modifier, onClick = onClick) {
        Column {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(AppTheme.sizes.resultImageHeight)
                    .background(AppTheme.colors.surfaceContainerHigh),
                contentAlignment = Alignment.Center,
            ) {
                Image(
                    painter = painterResource(gemArtImage(art)),
                    contentDescription = null,
                    modifier = Modifier.size(AppTheme.sizes.brandMark),
                )
            }
            Column(
                modifier = Modifier.padding(AppTheme.spacing.md),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
            ) {
                Text(
                    text = title,
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = description,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                AccentBadge(label = countLabel)
            }
        }
    }
}

/** Dashed "more gems coming soon" teaser — curiosity + roadmap signal (plan §6). */
@Composable
private fun ComingSoonCard() {
    val outline = AppTheme.colors.outlineVariant
    val strokeWidth = AppTheme.sizes.borderWidth
    val corner = AppTheme.shapes.card
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .drawBehind {
                val stroke = strokeWidth.toPx()
                val dash = stroke * 6
                drawRoundRect(
                    color = outline,
                    style = Stroke(
                        width = stroke,
                        pathEffect = PathEffect.dashPathEffect(floatArrayOf(dash, dash)),
                    ),
                    cornerRadius = androidx.compose.ui.geometry.CornerRadius(
                        corner.topStart.toPx(size, this),
                    ),
                )
            }
            .padding(AppTheme.spacing.lg),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        Image(
            painter = painterResource(gemArtImage(GemArt.ComingSoon)),
            contentDescription = null,
            modifier = Modifier.size(AppTheme.sizes.iconHero),
        )
        Text(
            text = stringResource(Res.string.gems_coming_soon_title),
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onSurface,
        )
        Text(
            text = stringResource(Res.string.gems_coming_soon_desc),
            style = AppTheme.typography.bodySm,
            color = AppTheme.colors.onSurfaceVariant,
        )
    }
}

/** Horizontal rail of the user's saved gems (recipes first — they're the visual cards). */
@Composable
private fun SavedGemsRail(
    savedJokes: List<Joke>,
    savedRecipes: List<Recipe>,
    savedFacts: List<Fact>,
    savedTales: List<Tale>,
    savedPoems: List<Poem> = emptyList(),
    savedStories: List<Story> = emptyList(),
    onOpenJokes: () -> Unit,
    onOpenDanestaniha: () -> Unit,
    onOpenShahnameh: () -> Unit,
    onOpenRecipe: (recipeId: String) -> Unit,
    onOpenTale: (taleId: String) -> Unit = {},
    onOpenPoem: (poemId: String) -> Unit = {},
    onOpenStory: (storyId: String) -> Unit = {},
) {
    val lang = AppTheme.language
    LazyRow(
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        contentPadding = PaddingValues(end = AppTheme.spacing.lg),
    ) {
        items(savedRecipes, key = { "recipe-" + it.id }) { recipe ->
            SavedGemCard(
                iconName = "skillet",
                text = recipe.title.resolve(lang),
                onClick = { onOpenRecipe(recipe.id) },
            )
        }
        items(savedTales, key = { "tale-" + it.id }) { tale ->
            SavedGemCard(
                iconName = "menu_book",
                text = tale.title.resolve(lang),
                onClick = { onOpenTale(tale.id) },
            )
        }
        items(savedFacts, key = { "fact-" + it.id }) { fact ->
            SavedGemCard(
                iconName = "lightbulb",
                text = fact.text.resolve(lang),
                onClick = onOpenDanestaniha,
            )
        }
        items(savedJokes, key = { "joke-" + it.id }) { joke ->
            SavedGemCard(
                iconName = "sentiment_very_satisfied",
                text = joke.text.resolve(lang),
                onClick = onOpenJokes,
            )
        }
        items(savedPoems, key = { "poem-" + it.id }) { poem ->
            SavedGemCard(
                iconName = "history_edu",
                text = poem.title.resolve(lang),
                onClick = { onOpenPoem(poem.id) },
            )
        }
        items(savedStories, key = { "story-" + it.id }) { story ->
            SavedGemCard(
                iconName = "auto_stories",
                text = story.title.resolve(lang),
                onClick = { onOpenStory(story.id) },
            )
        }
    }
}

@Composable
private fun SavedGemCard(iconName: String, text: String, onClick: () -> Unit) {
    AppCard(modifier = Modifier.width(AppTheme.sizes.compactItemCardWidth), onClick = onClick) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.md),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppIcon(name = iconName, tint = AppTheme.colors.primary)
            Text(
                text = text,
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurface,
                maxLines = 3,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}

/** One row in the saved-gems bottom sheet. */
@Composable
private fun SavedSheetRow(iconName: String, label: String, onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIcon(name = iconName, tint = AppTheme.colors.primary)
        Text(
            text = label,
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurface,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
        )
    }
}
